import { render, staticRenderFns } from "./RelatedPersonTable.vue?vue&type=template&id=361d7082&"
import script from "./RelatedPersonTable.vue?vue&type=script&lang=js&"
export * from "./RelatedPersonTable.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPersonTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports